import { client, authHeaders } from 'repositories/client';
import { paths } from 'repositories/device/paths';
import {
  AvailableAppsResponse,
  DeviceDetailResponse,
  DeviceEmailResponse,
} from 'repositories/device/responseType';

const detail = async (uid: string): Promise<DeviceDetailResponse> => {
  const response = await client.get<DeviceDetailResponse>(paths.clientPolicy, {
    headers: await authHeaders({ iphoneUid: uid }),
  });
  return response.data;
};

const availableApps = async (): Promise<AvailableAppsResponse> => {
  const response = await client.get<AvailableAppsResponse>(paths.apps, {
    headers: await authHeaders(),
  });
  return response.data;
};

const getEmail = async (): Promise<DeviceEmailResponse> => {
  const response = await client.get(paths.email, {
    headers: await authHeaders(),
  });
  return response.data;
};

const registerEmail = async (email: string): Promise<void> => {
  const params = new FormData();
  params.append('email', email);
  await client.post(paths.email, params, {
    headers: await authHeaders(),
  });
};

const deleteEmail = async (): Promise<void> => {
  await client.delete(paths.email, {
    headers: await authHeaders(),
  });
};

const emailActivation = async (activationCode: string): Promise<void> => {
  const params = new FormData();
  params.append('activation_code', activationCode);
  await client.put(paths.emailActivation, params);
};

export const device = {
  detail,
  availableApps,
  registerEmail,
  deleteEmail,
  getEmail,
  emailActivation,
};
